import { ACTIVE_NETWORK } from './appConfig';

// Auto-derive the 0x-prefixed hex form from the decimal chainId so we can't
// desync the two by mistake. (Wallets require the hex form for JSON-RPC calls.)
const toChainIdHex = (n) => '0x' + Number(n).toString(16);

// MST Chain configurations
export const NETWORKS = {
  mainnet: {
    chainId: 4646,
    name: 'MST Chain',
    displayName: 'MST',
    rpcUrls: [
      'https://mariorpc.mstblockchain.com',
      'https://craftrpc.mstblockchain.com',
      'https://4646.rpc.thirdweb.com'
    ],
    nativeCurrency: {
      name: 'MSTC',
      symbol: 'MSTC',
      decimals: 18
    },
    blockExplorerUrls: ['https://mstscan.com']
  },
  testnet: {
    chainId: 91562037,
    name: 'MST Testnet',
    displayName: 'MST',
    rpcUrls: [
      'https://testnetrpc.mstblockchain.com'
    ],
    nativeCurrency: {
      name: 'tMSTC',
      symbol: 'tMSTC',
      decimals: 18
    },
    blockExplorerUrls: ['https://testnet.mstscan.com']
  }
};

// Attach derived hex form to each entry.
Object.keys(NETWORKS).forEach((k) => {
  NETWORKS[k].chainIdHex = toChainIdHex(NETWORKS[k].chainId);
});

export const ACTIVE = NETWORKS[ACTIVE_NETWORK];

// Format for wallet_addEthereumChain
export const getAddNetworkParams = () => ({
  chainId: ACTIVE.chainIdHex,
  chainName: ACTIVE.name,
  nativeCurrency: ACTIVE.nativeCurrency,
  rpcUrls: ACTIVE.rpcUrls,
  blockExplorerUrls: ACTIVE.blockExplorerUrls
});

// Robustly parse a chainId that might arrive as: hex string ("0x1226"),
// decimal string ("4646"), number, bigint, or a BigNumber-like object.
// Different wallets are inconsistent — SafePal in particular has returned
// decimal strings in some versions, which broke naive parseInt(x, 16).
export const parseChainId = (chainId) => {
  if (chainId == null) return null;
  if (typeof chainId === 'number') return chainId;
  if (typeof chainId === 'bigint') return Number(chainId);
  if (typeof chainId === 'string') {
    const s = chainId.trim();
    if (/^0x/i.test(s)) return parseInt(s, 16);
    if (/^\d+$/.test(s)) return parseInt(s, 10);
    const asHex = parseInt(s, 16);
    return Number.isNaN(asHex) ? null : asHex;
  }
  if (typeof chainId === 'object' && typeof chainId.toNumber === 'function') {
    try { return chainId.toNumber(); } catch (e) { return null; }
  }
  const n = Number(chainId);
  return Number.isNaN(n) ? null : n;
};

export const isCorrectNetwork = (chainId) => {
  const n = parseChainId(chainId);
  return n != null && n === ACTIVE.chainId;
};
